import { Component, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Media } from "../../../../../../../features/media/domain/models/media";

@Component({
  standalone: true,
  selector: "app-instagram-carousel-slide-preview",
  templateUrl: "./instagram-carousel-slide-preview.component.html",
  styleUrls: ["./instagram-carousel-slide-preview.component.scss"],
  imports: [TranslateModule],
})
export class InstagramCarouselSlidePreviewComponent {
  protected readonly media = input<Media | undefined>();
}
